export default "__VITE_ASSET__a5b29a93__"